import api from './axios';

// 获取用户基本资料
export const getUserProfile = async () => {
  const res = await api.get('/users/me/profile');
  return res.data;
};

// 创建用户基本资料
export const createUserProfile = async (data: any) => {
  const res = await api.post('/users/me/profile', data);
  return res.data;
};

// 更新用户基本资料
export const updateUserProfile = async (data: any) => {
  const res = await api.put('/users/me/profile', data);
  return res.data;
};

// 预约用：连络先电话の precheck（needs_phone / needs_name を返す）
export const getBookingContactPrecheck = async (): Promise<{ needs_phone: boolean; needs_name: boolean }> => {
  const res = await api.get('/users/me/booking-contact/precheck');
  return res.data;
};

// 预约用：连络先电话を保存（profile 未作成時は氏名も必須）
export const saveBookingContact = async (data: { phone_number: string; full_name?: string }) => {
  const res = await api.put('/users/me/booking-contact', data);
  return res.data;
};

// 智能保存（先判断是创建还是更新）
export const saveUserProfile = async (data: any) => {
  try {
    await getUserProfile();
    // 如果 get 成功，说明已存在，走更新
    const res = await updateUserProfile(data);
    return res;
  } catch (err: any) {
    if (err.response && err.response.status === 404) {
      // 如果 get 返回 404，走创建
      const res = await createUserProfile(data);
      return res;
    } else {
      // 其他错误抛出
      throw err;
    }
  }
};

// 根据邮编获取地址（使用 zipcloud API，日本地址用）
export const fetchAddressByPostalCode = async (postalCode: string): Promise<string> => {
  try {
    const res = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postalCode}`);
    const data = await res.json();
    if (data.results && data.results.length > 0) {
      const result = data.results[0];
      return `${result.address1}${result.address2}${result.address3}`; // 例：東京都杉並区上高井戸
    } else {
      throw new Error('Address not found');
    }
  } catch (err) {
    console.error('❌ 郵便番号検索失敗:', err);
    throw err;
  }
};
